import { gql } from "@apollo/client";

export const QUERY_GET_MATERIAL_COLUMN_CONFIG = `
  GetSavedMaterialColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      material_column_config
    }
  }
`;

export const QUERY_MATERIAL_EXTRACTED_DATA = `
  extractionDataQuery {
    extraction_data(order_by: {spec_page_extract: {created_at: desc}}) {
      id
      title
      manufacturer
      tag
      table_title
      LOCATION: additional_fields(path: "LOCATION")
      location: additional_fields(path: "location")
      grouped_parent: extraction_groups_as_child(where: {feature_instance: {feature_type_id: {_eq: 2}}}, distinct_on: extraction_id) {
        parent_extraction_id
      }
      spec_page_extract {
        id
        bb_x1
        bb_x2
        bb_y1
        bb_y2
        created_at
        mark_completed
        page_no
        spec_page {
          id
          page_number
          page_file_key
          width
          height
          specification {
            title
          }
        }
      }
    }
  }
`;

export const QUERY_EXTRACTION_HISTORY_DATA = `
 getExtractionHistory {
  extraction_data_progress_func {
    project_id
    status_wise_extraction_data
  }
}
`;

export const QUERY_GET_EXTRACTION_STATUS = gql`
  query getSpecificationsPK($id: uuid!) {
    specifications_by_pk(id: $id) {
      status_comment
      title
    }
  }
`;

export const QUERY_MATERIAL_EXTRACTED_COUNT = gql`
  query RowsExtracted($id: uuid!) {
    extraction_data_aggregate(
      where: {
        spec_page_extract: { spec_page: { specification_id: { _eq: $id } } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
